import { Injectable } from '@angular/core';
import { Column, TableCell } from 'pdfmake/interfaces';
import {Cell, Columns, Img, Line, PdfMakeWrapper, QR, Table, Txt} from 'pdfmake-wrapper';
import {ITable, ICell} from 'pdfmake-wrapper/lib/interfaces';
import { Sr } from '../interfaces/sr';
import { SrDetalle } from '../interfaces/srDetalle';
import { table } from 'console';

@Injectable({
  providedIn: 'root'
})
export class PdfsService {
  private sr:Sr;
  srD:SrDetalle;
  listSrD:SrDetalle[]=new Array ;
  constructor() {

    this.sr={
      dni:0,
      origen_nombre:"",
      email:"",
      telefono:0,
      origen_provincia:"",
      origen_localidad:"",
      origen_direccion:"",
      origen_altura:0,
      origen_cp:"",
      origen_piso_departamento:"",
      id_franja_horaria:1,
      destino_cuit:0,
      destino_nombre:"",
      destino_telefono:0,
      destino_provincia:"",
      destino_localidad:"",
      destino_direccion:"",
      destino_entrecalles:"",
      destino_altura:0,
      destino_cp:"",
      destino_email:"",
      destino_piso_departamento:"",
      is_contrareembolso:false,
      contrareembolso_valor:0,
      contrareembolso_pago:false
    };
    this.srD={
      id_sr: 0,
      id_bulto:0,
      observacion:'',
      valor_declarado:0,
      peso:0,
      estado:1
    };

  }
  async makeEtiquetaBulto(srParam:Sr, srDetalleParam:SrDetalle[]){
    const pdf =new PdfMakeWrapper();
    let logo= await new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).build();
    // pdf.background(logo);
this.sr=srParam;
this.listSrD=srDetalleParam;
    let prueba: Column[];
    // prueba=new Array<Column>{}
    let cont=0;
    await this.listSrD.forEach(async element => {
      if(cont===2){
        // pdf.add(new Txt('---------------------------').pageBreak('after').end);
        // pdf.add(this.createTableDetalle(await new Img(logo.image).height(45).width(40).build(),element));//info del destinatario
        // pdf.add(new Line([10,10], [30, 30]).end)
        cont=0;

      }else{
        // pdf.add(new Txt('---------------------------').end);
        // pdf.add(this.createTableDetalle(await new Img(logo.image).height(45).width(40).build(),element));//info del destinatario
        // // pdf.add(this.createTableDetalle(await new Img(logo.image).height(45).width(40).build(),element));//info del destinatario
        // // pdf.add(new Line([10,10], [30, 30]).end)
      }
      // pdf.add(new Txt('----------------------------------------------------------------------------------------------------------------------------').end);
      pdf.add(this.createTableDetalle(await new Img(logo.image).height(45).width(40).build(),element,cont));//info del destinatario

        pdf.add(new Txt('----------------------------------------------------------------------------------------------------------------------------').end);

      cont++;



    });

    // pdf.pageOrientation("landscape")
    pdf.create().open();

  }
  createTableDetalle(logo:any, detalle:SrDetalle, numero:Number): ITable{
    let tablita=new Table([[logo],[new Txt('SR-'+ String(this.sr.id).padStart(6, '0')).bold().alignment('center').end],
    [new Txt('Remitente: '+ this.sr.origen_nombre).bold().fontSize(8).end],
    [new Txt(this.sr.origen_direccion+' '+this.sr.origen_piso_departamento+' (CP: '+ this.sr.origen_cp+'), '+ this.sr.origen_localidad+', '+this.sr.origen_provincia).fontSize(8).end],
    [new Txt('Telefono: '+ this.sr.telefono).bold().fontSize(8).end],
  ]).layout('noBorders').end;

  let bulto =new Table([[new QR('http://manager.crabslogistica.ar/cliente/'+this.sr.id+'/0').alignment('center').end],
    [new Txt(detalle.peso.toString()+'g').end]]).layout('noBorders').end;
  // pdf.add(new QR('http://manager.crabslogistica.ar/cliente/'+this.sr.id+'/0').alignment('center').pageBreak('after').end)
let destino=new Table([
      [new Txt('Nombre y Apellido: ').bold().fontSize(8).end,new Txt( this.sr.destino_nombre).fontSize(8).end ],
      [new Txt('Direccion Destino: ').bold().fontSize(8).end,new Txt( this.sr.destino_direccion+' '+this.sr.destino_piso_departamento+' (CP: '+ this.sr.destino_cp+'), '+ this.sr.destino_localidad+', '+this.sr.destino_provincia).fontSize(8).end ],
      [new Txt('Entrecalles: ').bold().fontSize(8).end,new Txt( this.sr.destino_entrecalles.toString()).fontSize(8).end],
      [new Txt('DNI: ').bold().fontSize(8).end,new Txt( this.sr.destino_cuit.toString()).fontSize(8).end],
      [new Txt('Telefono: ').bold().fontSize(8).end,new Txt( this.sr.destino_telefono.toString()).fontSize(8).end],
]).layout('noBorders').end;
if(numero===2){
  return new Table([[tablita],[bulto],[destino]]).pageBreak('before').end;
}else{
  return new Table([[tablita],[bulto],[destino]]).end;
}


    // return new Table([
    //   // [new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).width(10).height(10).build(),
    //   [logo,
    //   tablita
    //   ]
    // ]).layout('noBorders').end;
  }


  createTableOrigen(logo:any): ITable{
    let tablaSR=new Table([
      [new Txt('Direccion: ').bold().end,this.sr.origen_direccion+' '+this.sr.origen_piso_departamento+' (CP: '+ this.sr.origen_cp+'), '+ this.sr.origen_localidad+', '+this.sr.origen_provincia],
      [new Txt('Nombre y Apellido: ').bold().end, this.sr.origen_nombre],
      [new Txt('DNI: ').bold().end, this.sr.dni]

    ]).layout('noBorders').end;
    let tablita=new Table([
      [new Txt('SR-'+ String(this.sr.id).padStart(6, '0')).bold().alignment('center').end],
      [new Txt('Remitente').bold().alignment('center').end],
      [tablaSR]
    ])
    .layout('lightHorizontalLines')

    .end;
  return new Table([
    // [new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).width(10).height(10).build(),
    [logo,
    tablita
    ]
  ]).layout('noBorders').end;
}
 createTableDestino(): ITable{
    let tablaSR=new Table([
      [new Txt('Direccion Destino: ').bold().end,this.sr.destino_direccion+' '+this.sr.destino_piso_departamento+' (CP: '+ this.sr.destino_cp+'), '+ this.sr.destino_localidad+', '+this.sr.destino_provincia],
      [new Txt('Nombre y Apellido: ').bold().end, this.sr.destino_nombre],
      [new Txt('DNI: ').bold().end, this.sr.destino_cuit]

    ]).layout('noBorders').end;
    let tablita=new Table([
      [new Txt('Destinatario').bold().alignment('center').end],

      [tablaSR]
    ])
    .layout('lightHorizontalLines')

    .end;
  return new Table([
    // [new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).width(10).height(10).build(),
    ['',
    tablita
    ]
  ]).widths([40,'*']).layout('noBorders').end;
}
tablaEtiqueta():ITable{
    let tablaEtiqueta = new Table(
      [
        []]
      ).end;

return tablaEtiqueta
}
}
